module.exports = __webpack_public_path__ + "static/media/dexter-logo.488217a8.svg";